import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// --- DOM safety guard --------------------------------------------------------
// Browser extensions and in-page translators (e.g. Google Translate) mutate the
// DOM behind React's back: they replace text nodes with <font> wrappers. When
// React later reconciles, native removeChild/insertBefore throw
// ("The node to be removed is not a child of this node") and crash the whole
// tree into the ErrorBoundary (React issue #11538). Patch both to degrade
// gracefully instead of crashing. Translation keeps working.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      console.warn("Skipped removeChild on detached node (external DOM mutation).");
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn("Recovered insertBefore with detached reference node (external DOM mutation).");
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
  const originalReplaceChild = Node.prototype.replaceChild;
  Node.prototype.replaceChild = function (newNode, oldNode) {
    if (oldNode && oldNode.parentNode !== this) {
      console.warn("Recovered replaceChild with detached node (external DOM mutation).");
      return this.appendChild(newNode);
    }
    return originalReplaceChild.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
